import { Button } from '../../../Button';
import { ColumnDef } from '@tanstack/react-table';
import { ChevronDown } from 'lucide-react';

export const EXPANDABLE_COLUMN_ID = 'expandable';

export function ExpandableColumn<TData>(): ColumnDef<TData> {
  return {
    accessorKey: EXPANDABLE_COLUMN_ID,
    enableColumnFilter: false,
    enableSorting: false,
    enableHiding: false,
    size: 65,
    header: ({ table }) => (
      <Button
        className='eye:size-s! eye:align-middle'
        size='icon'
        variant='ghost'
        onClick={() =>
          table.toggleAllRowsExpanded(!table.getIsAllRowsExpanded())
        }
      >
        <ChevronDown
          className={`eye:size-1xs eye:transition-transform eye:duration-200 ${
            table.getIsAllRowsExpanded() ? 'eye:rotate-180' : ''
          }`}
        />
      </Button>
    ),
    cell: ({ row }) => (
      <Button
        className='eye:size-s! eye:align-middle'
        size='icon'
        variant='ghost'
        onClick={() => row.toggleExpanded(!row.getIsExpanded())}
      >
        <ChevronDown
          className={`eye:size-s eye:stroke-[1.5] eye:transition-transform eye:duration-200 ${
            row.getIsExpanded() ? 'eye:rotate-180' : ''
          }`}
        />
      </Button>
    ),
  };
}
